// src/store/slices/multiplierSlice.ts
/**
 * Multiplier markers between primary and secondary lines.
 * Stored in Redux so share/export can persist them.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { MultiplierMarkerState } from '../../types/redux';

const initialState: MultiplierMarkerState = {
  markers: [],
  nextId: 1,
};

export const multiplierSlice = createSlice({
  name: 'multipliers',
  initialState,
  reducers: {
    /**
     * Add a multiplier marker at the given value (already snapped externally).
     */
    addMultiplierMarker: (state, action: PayloadAction<number>) => {
      state.markers.push({
        id: `mult-${state.nextId}`,
        value: action.payload,
      });
      state.nextId += 1;
    },

    /**
     * Replace all multiplier markers (used for hydration).
     */
    setMultiplierMarkers: (state, action: PayloadAction<MultiplierMarkerState>) => {
      state.markers = action.payload.markers ?? [];
      state.nextId = action.payload.nextId ?? (action.payload.markers?.length ?? 0) + 1;
    },

    /**
     * Clear all multiplier markers.
     */
    clearMultiplierMarkers: (state) => {
      state.markers = [];
      state.nextId = 1;
    },
  },
});

export const {
  addMultiplierMarker,
  setMultiplierMarkers,
  clearMultiplierMarkers,
} = multiplierSlice.actions;

export default multiplierSlice.reducer;









